"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tagTense = {
    "VBG": "gerund",
    "VB": "present",
    "VBP": "present",
    "VBZ": "present",
    "MD": "present",
    "VBN": "past",
    "VBD": "past",
};
exports.default = exports.tagTense;
